import Lara from "@/presets/lara";

type CheckboxBoxOptions = {
  context: { checked: boolean };
  props: { disabled?: boolean; invalid?: boolean };
};

const basicLikeCheckboxPt = {
  ...Lara.checkbox,
  root: {
    class: [...Lara.checkbox.root.class, "!w-4", "!h-4", "inline-flex", "items-center", "align-middle"],
  },
  box: ({ context, props }: CheckboxBoxOptions) => {
    const base = Lara.checkbox.box({ context, props });
    return {
      class: [
        ...base.class,
        "!w-4",
        "!h-4",
        "!rounded",
        {
          "!border-gray-300 !bg-white": !context.checked && !props.invalid,
          "!border-red-500 !bg-white": !context.checked && props.invalid,
          "!border-university-primary !bg-indigo-base": context.checked && !props.invalid,
        },
        {
          "!peer-hover:border-gray-400": !props.disabled && !context.checked && !props.invalid,
          "!peer-hover:!border-university-primary !peer-hover:!bg-indigo-base":
            !props.disabled && context.checked && !props.invalid,
        },
      ],
    };
  },
  icon: {
    class: [...Lara.checkbox.icon.class, "!w-3", "!h-3", "!text-white"],
  },
};

export const applicationRequirementsFeesPaymentsPresets = {
  ...Lara,
  checkbox: basicLikeCheckboxPt,
};
